import { AxiosResponse } from 'axios';
import { API } from '../../utils/axios';
import { APIResponseStatus } from '../types';

class FileService {
  static async uploadMessageAttachments(params: {
    attachments: Array<{ file: Blob; name: string }>;
  }) {
    const formData = new FormData();
    formData.append('logo', 'logo');

    params.attachments.forEach((attachment) => {
      const fileName = attachment.name;
      formData.append('logo', attachment.file, fileName);
    });

    formData.append('resourceTag', 'attach');
    const response = await API.post<any, AxiosResponse<any>>('v1/resources/File', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data.resource.entry;
  }
  static uploadFile(params: { file: Blob; fileName: string; fileTag: string }) {
    const formData = new FormData();
    formData.append('tag', params.file, params.fileName);
    formData.append('tag', params.fileTag || 'avatar');
    return API.post<any, AxiosResponse<any>>('v1/resources/File', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((res) => res.data);
  }

  static deleteAvatarByTag(uuid = '00000000-0000-0000-0000-000000000000') {
    return API.delete<any, AxiosResponse<APIResponseStatus>>(
      `v1/resources/File/${uuid}/Tag?tag=avatar`,
    );
  }
}

export default FileService;
